export const socialLinks = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/sahilcncmachines?igsh=MXVmODBueDZkM3Z1YQ==',
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@sahilcncmachines',
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/sahil-cnc-machines/',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61556416797746&mibextid=ZbWKwL',
  },
] as const;
